// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import * as CryptoJS from 'crypto-js';
var cv = '';
function generateRandomString(length) {
  var text = '';
  let codeVerifier = localStorage.getItem('code_verifier');
  if (codeVerifier !== null && codeVerifier !== undefined && codeVerifier !== '') {
    cv = codeVerifier;
    return codeVerifier;
  } else {
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    for (var i = 0; i < length; i++) {
      text += possible.charAt(((Date.now() * i) * Date.now() + Date.now()) % possible.length);
    }
    cv = text;
    localStorage.setItem('code_verifier', cv);
    return text;
  }
}

function generateCodeChallenge(codeVerifier) {
  const codeChallange = base64URL(CryptoJS.SHA256(codeVerifier));
  
  return codeChallange + '&code_challenge_method=S256';
}

function base64URL(string: any) {
  return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}

export const environment = {
  envName: 'qa',
  env: 'qa',
  production: false,
  hostname: 'qanew.msts.toyota.com',
  redirectBaseUrl:'',
  reqtafBaseUrl:'https://api.qanew.msts.toyota.com/',
  createtafBaseUrl:'https://api.qanew.msts.toyota.com/',
  reqhistoryBaseUrl:'https://api.qanew.msts.toyota.com/',
  updatetafBaseUrl:'https://api.qanew.msts.toyota.com/',
  setuptimeBaseUrl: 'https://api.qanew.msts.toyota.com/',
  setupLocBaseUrl: 'https://api.qanew.msts.toyota.com/',
  setupAgentBaseUrl: 'https://api.qanew.msts.toyota.com/',
  scheduleVehicleBaseUrl: 'https://api.qanew.msts.toyota.com/',
  setupCapacityBaseUrl:'https://api.qanew.msts.toyota.com/',
  reportBaseUrl: 'https://api.qanew.msts.toyota.com/',
  downloadUrl: 'https://d2izaclme35b63.cloudfront.net/',
  loginBaseUrl: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/authorize',
  client_id: '60536f10-2a8a-4f3b-9d34-89847220c069',
  redirect_uri:'https://qanew.msts.toyota.com',
  loginParameters: '&response_type=code&response_mode=query&scope=openid&',
  state:'23343',
  code_challenge: '_3SPAlLuyvwPErgR887HA3eXt08o-P0-croGFmFIxbQ&code_challenge_method=S256',
  code_verifier: 'Iel9R9N41q9E1DrzRweZFudH2VlYDktcCpuPqGR1snqEMaI9b2hy0mTmrM8zyBrT5r2nW150GHCmTMFZiJ_5ZA',
  grant_type: 'authorization_code',
  logoutUrl: 'https://login.microsoftonline.com/common/oauth2/logout',
  saveTokenBaseUrl: 'https://2fd76qrp1m.execute-api.us-west-2.amazonaws.com/qa/api/saveToken/',
  tokenUrl: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/token',
  loginSaveAudit: 'https://api.qanew.msts.toyota.com/',
  hotelUrl: 'https://api.qanew.msts.toyota.com/',
  fileToken: 'https://api.qanew.msts.toyota.com/',
  signedUrl :'https://api.qanew.msts.toyota.com/',
  bucketName : 'itst-reports-qa/agents-profileImgs'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
